import React from 'react'

export default () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M7 5.78261L12.7826 0L14 1.21739L8.21739 7L14 12.7826L12.7826 14L7 8.21739L1.21739 14L0 12.7826L5.78261 7L0 1.21739L1.21739 0L7 5.78261Z" fill="#003A80"/>
  </svg>
)
